// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { Component, OnInit, OnDestroy } from '@angular/core';
import { pageSettings } from '@config';

@Component({
  selector: 'lfx-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent implements OnInit, OnDestroy {
  pageSettings = pageSettings;

  constructor() {
    this.pageSettings.pageEmpty = true;
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.pageSettings.pageEmpty = false;
  }
}
